export const APP_NAME = process.env.NEXT_PUBLIC_BRAND_NAME || 'Volcano';

export const HEAD_TITLES: Record<string, string> = {
  HomePage: `${APP_NAME} Official Store`,
  SignIn: `Account | ${APP_NAME}`,
  SignUp: `Create Account | ${APP_NAME}`,
  DiscountedProducts: `Discounted Products | ${APP_NAME}`,
  MyAccount: `Account | ${APP_NAME}`,
  CheckoutStep: ` - ${APP_NAME} - Checkout`,
  Cart: `Your shopping cart | ${APP_NAME}`
};
